export default __webpack_public_path__ + "static/media/gtx1650.7a3d61b4.jpg";